import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router';
import StyledContainer from './components/styledContainer';
import OrganizationSearchContent from '../organizationSearchContent';

export const OrganizationSearch = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const source = location.state?.source;
    const formData = location.state?.formData;

    const handleSelectOrganization = organization => {
        navigate('/auth/organization-search-detail', {
            state: {
                selectedOrganization: organization,
                source: source,
                formData: formData
            }
        });
    };

    return (
        <StyledContainer showVersion={false}>
            <OrganizationSearchContent
                onSelectOrganization={handleSelectOrganization}
                showHeader={true}
                onClose={() => navigate(-1)}
            />
        </StyledContainer>
    );
};

export default OrganizationSearch;
